import React, { useEffect, useState } from 'react';
import { Activity, Loader2 } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { metaAdsHealthAPI } from '../lib/api';

const KIND = { account_insights: 'Datos de cuentas', campaign_insights: 'Datos de campañas', adaccounts: 'Lista de cuentas', account_other: 'Otras de cuenta', other: 'Otras' };
const fmt = (iso) => new Date(iso).toLocaleString('es-ES', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });

export const MetaApiHealthCard = () => {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => { metaAdsHealthAPI.get(15).then(setD).catch((e) => setErr(e.message)); }, []);

  return (
    <Card data-testid="meta-api-health-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2"><Activity className="w-4 h-4 text-primary" />Salud de la conexión con Meta Ads (últimos 15 días)</CardTitle>
        <CardDescription>Cada llamada que el portal hace a la API de anuncios de Meta queda registrada aquí.{d?.logging_since && ` Registro desde el ${fmt(d.logging_since)}.`}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3 text-sm">
        {err ? <p className="text-red-700">{err}</p> : !d ? <Loader2 className="w-5 h-5 animate-spin" /> : (
          <>
            <div className="flex flex-wrap gap-3">
              <span className="rounded-full bg-emerald-100 text-emerald-800 px-3 py-1" data-testid="meta-health-ok">{d.ok} correctas</span>
              <span className={`rounded-full ${d.error ? 'bg-red-100 text-red-800' : 'bg-slate-100 text-slate-700'} px-3 py-1`} data-testid="meta-health-error">{d.error} con error</span>
              <span className={`rounded-full px-3 py-1 ${d.error_rate > 15 ? 'bg-red-100 text-red-800' : 'bg-slate-100 text-slate-700'}`} data-testid="meta-health-rate">Tasa de error: {d.error_rate}%</span>
            </div>
            {Object.keys(d.by_kind).length > 0 && (
              <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                {Object.entries(d.by_kind).map(([k, v]) => (
                  <div key={k} className="rounded-md border px-3 py-2" data-testid={`meta-health-kind-${k}`}>
                    <p className="text-xs text-muted-foreground">{KIND[k] || k}</p>
                    <p className="font-medium">{v.ok} ok · {v.error} error</p>
                  </div>
                ))}
              </div>
            )}
            {d.top_errors.length > 0 ? (
              <div className="space-y-1" data-testid="meta-health-errors">
                <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Errores más frecuentes</p>
                {d.top_errors.map((e, i) => (
                  <p key={i} className="text-xs"><b>{e.count}×</b> {e.code ? `(#${e.code}) ` : ''}{e.message || 'Sin mensaje'} <span className="text-muted-foreground">· último {fmt(e.last)}</span></p>
                ))}
              </div>
            ) : <p className="text-xs text-muted-foreground">Sin errores registrados.</p>}
          </>
        )}
      </CardContent>
    </Card>
  );
};
